export const advisorConfig_DevMode = 'devMode';
export const advisorConfig_HideNegative = 'hideNegative';
export const advisorConfig_EnableKickstart = 'enableKickstart';
export const advisorConfig_NumberOfKickstartQuestions = 'numberOfKickstartQuestions';
// Dev-only: reveal order-set protocol cards in the DDX list. Order-set protocols
// are hidden from the advisor by default (their orders still surface in the
// Suggested Workup); this toggle lets developers see the underlying cards.
export const advisorConfig_ShowOrderSetProtocols = 'showOrderSetProtocols';
//# sourceMappingURL=types.js.map